export const PROJECTS_LIMIT_BASIC = 1;
export const SCREENS_LIMIT_BASIC = 5;
